import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  alertModalWrapper: {
    backgroundColor: Theme.withOpacity(Theme.black, 0.8),
    height: Theme.px(1080),
    width: Theme.px(1920),
  },
  alertModalItem: {
    position: 'absolute',
  },
  arrowDisabled: {
    tintColor: Theme.disabledColor,
  },
  arrowEnabled: {
    tintColor: Theme.enabledColor,
  },
  arrowLeft: {
    height: Theme.px(38),
    left: Theme.px(290),
    position: 'absolute',
    top: Theme.px(501),
    width: Theme.px(23),
  },
  arrowRight: {
    height: Theme.px(38),
    left: Theme.px(1615),
    position: 'absolute',
    top: Theme.px(501),
    width: Theme.px(23),
  },
  detailsViewWrapper: {
    alignItems: 'center',
    height: Theme.px(1080),
    justifyContent: 'flex-start',
    width: Theme.px(1920),
  },
  focusTrap: {
    height: 1,
    opacity: 0,
    width: 1,
  },
  pager: { flex: 1 },
});
